export default "__VITE_ASSET__521c2c21__"